export function courseSelectHandlerFactory(productName, navigationEvent) {
  return course => () =>
    navigationEvent(`/product/${productName}/lessons/preview/${course}`)
}

export function classSelectHandlerFactory(productName, navigationEvent) {
  return (course, instance) => () =>
    navigationEvent(
      `/product/${productName}/lessons/teach/${course}?class=${instance}`,
    )
}
export function gotoDashboardHandlerFactory(navigationEvent) {
  return () => navigationEvent('/')
}
